module.exports = __webpack_public_path__ + "2c416a21ac0729e826f92fb60075d0e5.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/Lato-MediumItalic.ttf
// module id = 984
// module chunks = 0